import React from "react";

const CheckPaymentModal = ({ isOpen, onClose, order }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 overflow-auto">
      <div className="bg-gray-900 text-white w-full max-w-md rounded-lg shadow-lg p-6">
        <h2 className="text-xl font-bold mb-4">Información de Pago - {order.id}</h2>

        <div className="mb-4">
          <p className="text-gray-400 text-sm">Estado del Pago</p>
          <p className={`font-semibold ${order.payment === "Pagado" ? "text-green-400" : "text-yellow-400"}`}>
            {order.payment}
          </p>
        </div>

        <div className="mb-4">
          <p className="text-gray-400 text-sm">Método de Pago</p>
          <p className="font-semibold">{order.paymentMethod || "No especificado"}</p>
        </div>

        <div className="mb-4">
          <p className="text-gray-400 text-sm">Fecha y Hora de Pago</p>
          <p className="font-semibold">{order.paymentDate || "Pendiente"}</p>
        </div>

        {order.paymentProof && (
          <div className="mb-4">
            <p className="text-gray-400 text-sm mb-2">Comprobante de Pago</p>
            <img
              src={order.paymentProof}
              alt="Comprobante de Pago"
              className="w-full rounded-lg border border-gray-800"
            />
          </div>
        )}

        <div className="flex justify-end gap-2">
          <button
            className="bg-gray-800 hover:bg-gray-700 px-4 py-2 rounded"
            onClick={onClose}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckPaymentModal;
